export enum ProcessResultType {
    None = 0,
    Success = 1,
    Fail = 2,
    Warning = 3,
    Info = 4,
    Exeption = 5
}

export interface ProcessResult {
    result: ProcessResultType;
    message: string | null;
    messageType: string | null;
    resultEX: any | null;
    resultEXType: string | null;
}